import { Icon, Section } from '@advanza/advanza_generic'
import React from 'react'
import { Navigate } from 'react-router-dom'

interface BackButtonProps {
    fallBack: string
}

class BackButton extends React.Component<BackButtonProps, { redirect: string | false }> {
    private readonly previousLocation: string
    private readonly currentLocation: string
    constructor(props: BackButtonProps) {
        super(props)
        this.goToPreviousPage = this.goToPreviousPage.bind(this)
        this.mustUseFallback = this.mustUseFallback.bind(this)
        this.state = { redirect: false }
        //@ts-ignore
        this.previousLocation = window.previousRoute
        this.currentLocation = window.location.pathname
    }

    mustUseFallback() {
        const forbiddenUrls = ['login', 'logout']
        if (this.currentLocation === this.previousLocation) {
            return true
        }

        return forbiddenUrls.some((forbidden) => this.previousLocation.includes(forbidden))
    }

    goToPreviousPage() {
        const { fallBack } = this.props

        if (this.mustUseFallback()) {
            return this.setState({ redirect: fallBack || '/' })
        } else {
            window.history.go(-1)
        }
    }

    render() {
        const { redirect } = this.state
        if (redirect) {
            return <Navigate to={redirect} replace />
        }
        return (
            <button className="back-button" onClick={this.goToPreviousPage}>
                <Section y="min" x="min">
                    <Icon large>arrow_back</Icon>
                </Section>
            </button>
        )
    }
}

export default BackButton
